export default {"src":"/_next/static/media/primary_100_chevron_down.1443acf0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};